import axios from 'axios';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { injectIntl } from 'react-intl';
import { ERROR, WARNING } from '~/types/toast.types';

import { debounce } from '../../../utils/helper.utils';
import EcInput from '../EcInput/EcInput';
import EcPersistentTooltip from '../EcPersistentTooltip/EcPersistentTooltip';
import { validateDate } from './EcDateInput.data';

class EcDateInput extends Component {
  constructor(props) {
    super(props);

    this.state = { call: null, warning: false, tooltipOptions: {} };
  }

  getWarningTooltip = () => {
    const { intl } = this.props;
    return {
      message: intl.formatMessage({
        id: 'EcDateInput.valueTooFarOut',
        defaultMessage: 'This value seems to be too far out.',
        description: 'Warning message for date that seems unrealistic',
      }),
      type: WARNING,
    };
  };

  getErrorTooltip = () => {
    const { intl } = this.props;
    return {
      message: intl.formatMessage({
        id: 'EcDateInput.invalidValue',
        defaultMessage: 'Invalid value for date field.',
        description: 'Error message for invalid date input',
      }),
      type: ERROR,
    };
  };

  cancelValidateCall() {
    const { intl } = this.props;
    const { call } = this.state;

    if (call) {
      call.cancel(
        intl.formatMessage({
          id: 'EcDateInput.cancelValidation',
          defaultMessage: 'Canceling this request due to new one.',
          description: 'Message when canceling date validation request',
        }),
      );
    }
  }

  hideTooltip() {
    this.setState({ tooltipOptions: {} });
  }

  showTooltip(tooltipOptions) {
    this.setState({ tooltipOptions });
  }

  validateDateError(inputDate, err) {
    const { onDateInputChange } = this.props;

    if (!axios.isCancel(err)) {
      this.showTooltip(this.getErrorTooltip());
      onDateInputChange({
        display_value: inputDate,
        value: inputDate,
        error: true,
      });
    }
  }

  validateDateSuccess(res) {
    this.props.onDateInputChange({
      display_value: res.raw_value,
      value: res.value,
    });

    if (res.show_warning) {
      this.showTooltip(this.getWarningTooltip());
    } else {
      this.hideTooltip();
    }
  }

  dateValidator(inputDate) {
    this.setState({ call: axios.CancelToken.source() }, () => {
      validateDate(inputDate, this.state.call.token)
        .then(this.validateDateSuccess.bind(this))
        .catch(this.validateDateError.bind(this, inputDate));
    });
  }

  debouncedDateValidator = debounce(this.dateValidator, 400);

  render() {
    const { inputDate, placeholder, isDisabled, error, onDateInputChange } =
      this.props;

    return (
      <EcPersistentTooltip tooltipOptions={this.state.tooltipOptions}>
        <EcInput
          input={{
            value: inputDate,
            onChange: (event) => {
              const dateInput = event.target.value;
              onDateInputChange({
                display_value: dateInput,
                value: dateInput,
                disableForm: true,
              });
              this.hideTooltip();

              if (dateInput.length > 2) {
                this.cancelValidateCall();
                this.debouncedDateValidator(dateInput);
              } else if (dateInput === '') {
                onDateInputChange(null);
              }
            },
            onBlur: () => this.hideTooltip(),
            onFocus: () => error && this.showTooltip(this.getErrorTooltip()),
          }}
          placeholder={placeholder}
          width="100%"
          isDisabled={isDisabled}
          error={error}
        />
      </EcPersistentTooltip>
    );
  }
}

EcDateInput.defaultProps = {
  inputDate: '',
  isDisabled: false,
  error: false,
};

EcDateInput.propTypes = {
  inputDate: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
  error: PropTypes.bool,
  onDateInputChange: PropTypes.func.isRequired,
};

export default injectIntl(EcDateInput);
